import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";

// Server-side paginated + searchable fetch, scoped to the active site.
export function usePagedData(path, pageSize = 50) {
  const { activeSite } = useSite();
  const [state, setState] = useState({ items: [], stats: {}, total: 0, pages: 1 });
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  // reset to first page whenever the query or site changes
  useEffect(() => { setPage(1); }, [q, activeSite]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const sep = path.includes("?") ? "&" : "?";
      const { data } = await api.get(
        `${path}${sep}site=${activeSite}&page=${page}&page_size=${pageSize}&q=${encodeURIComponent(q)}`
      );
      setState({ items: data.items || [], stats: data.stats || {}, total: data.total || 0, pages: data.pages || 1 });
    } catch (e) {
      setState({ items: [], stats: {}, total: 0, pages: 1 });
    } finally {
      setLoading(false);
    }
  }, [path, activeSite, page, pageSize, q]);

  useEffect(() => { load(); }, [load]);

  return { ...state, page, setPage, q, setQ, loading, pageSize, reload: load };
}
